const projects = [
  {
    title: "Vote Conroy Irving",
    slug: "vote-conroy-irving",
    location: "Toronto, Ontario",
    description: "A high-impact campaign platform designed to mobilize support with bold messaging, fast access to event details, and a clean, persuasive digital experience tailored for public engagement.",
    image: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&q=80&w=1600",
    link: "https://www.voteconroyirving.ca/",
    tag: "Campaign Platform",
    year: 2026,
    roles: ["Campaign UX", "Content Strategy", "Conversion Design"],
    outcome: "Clearer supporter journey and stronger digital engagement"
  },
  {
    title: "Wooden aspects",
    slug: "woodenaspects",
    location: "Bloomington, Minnesota",
    description: "A bold, contemporary template/sample concept for a design-forward brand experience. This piece showcases a polished editorial layout with strong visual hierarchy and a flexible framework for future customization.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=1600",
    link: "https://obrianbaxter.com/woodenaspects/",
    tag: "Template / Sample",
    year: 2026,
    roles: ["Visual Direction", "Layout System", "UI Concept"],
    outcome: "Editorial-style sample concept for rapid presentation"
  },
  {
    title: "Explore Negril",
    slug: "explore-negril",
    location: "Negril, Jamaica",
    description: "Architecting a comprehensive digital ecosystem for Jamaica’s premier tourism hub. This platform synthesizes real-time travel logistics with immersive UX, leveraging high-performance SEO and specialized service integration to streamline the Caribbean travel experience for global visitors.",
    image: "/static/media/explore-negril.jpg",
    link: "https://explorenegril.com",
    tag: "Tourism Ecosystem",
    year: 2026,
    roles: ["UX/UI Design", "Performance Optimization", "Digital Strategy"],
    outcome: "Dominant organic search placement for regional travel keywords and 40% increase in vendor referral traffic"
},
{
    title: "North Star Arbor Care",
    slug: "north-star-arbor-care",
    location: "Roseville, Minnesota",
    description: "Engineering a high-conversion digital interface for Minnesota’s premier tree care specialists. This system integrates local SEO dominance with a surgical UX approach, transforming a traditional service-based business into a modern, lead-generating machine for the Twin Cities metro.",
    image: "/static/media/north-star-arbor-care.jpg",
    link: "https://northstartreeMN.com",
    tag: "Service Architecture",
    year: 2025,
    roles: ["Design System", "React Architecture", "Lead Generation"],
    outcome: "54% YoY lead growth and 62% increase in local inquiries"
  },
  {
    title: "Conroy Irving",
    slug: "conroy-irving",
    location: "Toronto, Ontario",
    description: "A minimalist digital sanctuary designed for an Ontario-based author. The architecture prioritizes narrative flow and atmospheric design, creating a sophisticated bridge between the author’s literary portfolio and a global readership.",
    image: "/static/media/conroy-irving.jpg",
    link: "https://conroyirving.com",
    tag: "Literary Branding",
    year: 2024,
    roles: ["UX Strategy", "Identity System", "Storytelling UI"],
    outcome: "40% increase in newsletter conversions"
  },
  {
    title: "NyaCreate",
    slug: "nyacreate",
    location: "Kingston, Jamaica",
    description: "A high-fidelity showcase for a premier digital graphic artist. Engineered to highlight Caribbean creative innovation through a bold, modern, and motion-heavy interface.",
    image: "/static/media/nya-create.jpg",
    link: "https://nyacreate.com",
    tag: "Creative Ecosystem",
    year: 2023,
    roles: ["Motion UI", "CMS Pipeline", "Performance Tuning"],
    outcome: "30% increase in international clients"
  },
  {
    title: "ShipMindJa",
    slug: "shipmindja",
    location: "Manchester, Jamaica",
    description: "Architecting a seamless logistics portal for Caribbean freight forwarding. This system streamlines complex shipping data into a high-performance React dashboard, prioritizing real-time tracking accuracy and surgical precision in international trade UX.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80&w=2000",
    link: "https://shipmindja.com",
    tag: "Logistics Infrastructure",
    year: 2023,
    roles: ["Dashboard UX", "Data Architecture", "API Integration"],
    outcome: "Enhanced operational efficiency for cross-border logistics"
  }
];

export default projects;
